export default __webpack_public_path__ + "static/media/ArrowLeft.38edd51d.svg";